// Re-applies the URL hash scroll once the homepage has finished loading, so links like /#contact from other pages land on their section instead of the hero.
class AnchorScroll extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    if (document.readyState === 'complete') {
      this.#scrollToHash();
    } else {
      window.addEventListener('load', () => this.#scrollToHash(), { once: true, signal });
    }
    window.addEventListener('hashchange', () => this.#scrollToHash(), { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #scrollToHash() {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }
}

if (!customElements.get('s-anchor-scroll')) {
  customElements.define('s-anchor-scroll', AnchorScroll);
}
